import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import FeatureFlagContext from './FeatureFlagContext';
import * as QueryParams from 'components/Explorer/models/query_params';
import fetchJSON from 'util/fetchJSON';

const FeatureFlagProvider = ({ children }) => {
  const location = useLocation();
  const [featureFlags, setFeatureFlags] = useState([]);

  useEffect(() => {
    const controller = new AbortController();

    const updateFeatureFlags = async () => {
      try {
        const newFeatureFlags = await fetchJSON(`${QueryParams.BASE_JSON_PATH}/features`, {
          signal: controller.signal
        });

        if (!Array.isArray(newFeatureFlags)) {
          throw new Error(`Bad response from Flipper: ${JSON.stringify(newFeatureFlags)}`);
        }

        setFeatureFlags(newFeatureFlags);
      } catch (error) {
        if (error?.name === 'AbortError') return;
        // Surfacing the error via `throw` here becomes an unhandled rejection
        // because the call from useEffect isn't awaited. Log and keep the
        // previous featureFlags state so a transient blip doesn't blank
        // flags app-wide.
        console.error('Failed to load feature flags', error);
      }
    };

    updateFeatureFlags();

    return () => controller.abort();
  }, [location]);

  return <FeatureFlagContext.Provider value={featureFlags}>{children}</FeatureFlagContext.Provider>;
};

export default FeatureFlagProvider;
